<footer class="app-footer">
  <span>&copy; 2020 All rights reserved. Developed by <a href="http://www.seteados.com" target="_blank">Seteados</a> </span>
</footer>
